import { render, staticRenderFns } from "./SalesUserDistributorDetails.vue?vue&type=template&id=4e00070c&"
import script from "./SalesUserDistributorDetails.vue?vue&type=script&lang=js&"
export * from "./SalesUserDistributorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports